<template>
  <div class="page-avatars" :class="`page-avatars--${size}`">
    <Tooltip v-for="page in pages" :key="page.id" :text="page.name || ''" position="top">
      <span class="page-avatar">
        <img v-if="page.avatar" :src="page.avatar" alt="">
        <span v-else>{{ (page.name || '?')[0].toUpperCase() }}</span>
      </span>
    </Tooltip>
  </div>
</template>

<script>
import Tooltip from '../tooltip/tooltipInit.vue'

export default {
  name: 'BoostingPageAvatars',
  components: { Tooltip },
  props: {
    pages: { type: Array, default: () => [] },
    size:  { type: String, default: 'small' },
  },
}
</script>

<style scoped>
.page-avatars { display: inline-flex; align-items: center; flex-shrink: 0; }
.page-avatars > * + * { margin-left: -6px; }
.page-avatar {
  border-radius: 50%;
  overflow: hidden;
  background: #f1edf5;
  color: #6B1F4D;
  border: 1.5px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  box-sizing: border-box;
}
.page-avatar img { width: 100%; height: 100%; object-fit: cover; }
.page-avatars--small .page-avatar { width: 20px; height: 20px; font-size: 9px; }
.page-avatars--large .page-avatar { width: 30px; height: 30px; font-size: 12px; }
.page-avatars--large > * + * { margin-left: -8px; }
</style>
